// Shared constants & helpers for the Daily Revenue module.
export const REVENUE_FIELDS = ["cash", "card", "wolt", "foodora", "kiosk", "app"];

export const FIELD_LABELS = {
  cash: "Készpénz",
  card: "Kártya",
  wolt: "Wolt",
  foodora: "Foodora",
  kiosk: "Kiosk",
  app: "App",
};

export const SHORTAGE_TYPE_LABELS = {
  ...FIELD_LABELS,
  other: "Egyéb",
};

// Magyar bankjegyek + érmék (csökkenő sorrendben).
export const DENOMINATIONS = [
  20000, 10000, 5000, 2000, 1000, 500, 200, 100, 50, 20, 10, 5,
];

export const STATUS_LABELS = {
  new: "Új bejegyzés",
  verifying: "Ellenőrzés alatt",
  approved: "Lezárva",
  shortage: "Hiány",
  shortage_resolved: "Hiány rendezve, jóváhagyva",
};

export const STATUS_TONES = {
  new: "bg-slate-100 text-slate-700 dark:bg-slate-800/60 dark:text-slate-300",
  verifying: "bg-sky-100 text-sky-800 dark:bg-sky-500/15 dark:text-sky-300",
  approved: "bg-emerald-100 text-emerald-800 dark:bg-emerald-500/15 dark:text-emerald-300",
  shortage: "bg-rose-100 text-rose-800 dark:bg-rose-500/15 dark:text-rose-300",
  shortage_resolved: "bg-emerald-100 text-emerald-800 dark:bg-emerald-500/15 dark:text-emerald-300",
};

const huFmt = new Intl.NumberFormat("hu-HU", { maximumFractionDigits: 0 });
export const formatFt = (n) =>
  n == null || Number.isNaN(Number(n)) ? "—" : `${huFmt.format(Number(n))} Ft`;

export const formatDate = (s) => {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleString("hu-HU", {
      year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return s; }
};

export const formatDay = (s) => {
  if (!s) return "—";
  // s is YYYY-MM-DD
  return s.replace(/-/g, ". ") + ".";
};

export function StatusBadge({ status }) {
  return (
    <span
      data-testid={`rev-status-${status}`}
      className={`inline-flex items-center whitespace-nowrap rounded-full px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${STATUS_TONES[status] || ""}`}
    >
      {STATUS_LABELS[status] || status}
    </span>
  );
}
